import * as React from "react";
import DocumentTitle from "../../misc/components/DocumentTitle";
import { ODataParams, Query } from "../../Components/Query";
import { RolesTable } from "./RolesTable";
import { useCurrentStudyConfigurationContext } from "../../Core/CurrentStudyConfigurationContext";
import { RolePermissionsOverview } from "./RolePermissionsOverview";
import { useWebPortalApiClient } from "../../misc/api/WebPortalTokenClient";

export const RoleManagementSummary = () => {
    const { study } = useCurrentStudyConfigurationContext();
    const client = useWebPortalApiClient();

    const handleRefresh = async (params: ODataParams) => {
        let filter = params.filter ? `(${params.filter}) and ` : '';
        filter += `studyId eq ${study.id}`;

        return await client.client.getRoles('id,name,users,permissions,reports', filter, params.orderby, 'users($select=id;$count=true),permissions($select=id;$count=true)', params.top, params.skip, undefined, true);
    }

    return (
        <DocumentTitle title="Role Management | Vitalograph Web Portal">
            <div id="roleSummary" className="row">
                <div className="col-md-12">
                    <Query onRefresh={handleRefresh} initialOrdering={[{
                        field: "name",
                        condition: "asc"
                    }]}>
                        <RolesTable />
                    </Query>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <h3 className="text-primary">Permissions Overview</h3>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <RolePermissionsOverview />
                </div>
            </div>
        </DocumentTitle>
    );
}
